import { BackendListTable } from "./backend-list-table";
import type { StatusT } from "@/app/types/status";

export type PostTableDataT = {
  id: string;
  title: string;
  status: StatusT;
  slug: string;
  updatedAt: string;
};

export type ContactPersonTableDataT = {
  id: string;
  title: string;
  status: StatusT;
  slug: string;
  email: string;
  phone: string;
  position: string;
  location: string;
  updatedAt: string;
};

type ColumnT = {
  key: string;
  label: string;
  sortable?: boolean;
};

type RouteConfigT = {
  basePath: string;
  slugField: string;
};

type BackendListWrapperPropsT = {
  data: PostTableDataT[];
  columns: ColumnT[];
  searchableFields: string[];
  routeConfig: RouteConfigT;
  searchPlaceholder?: string;
  emptyMessage?: string;
  isLoading?: boolean;
};

export function BackendListWrapper({
  data,
  columns,
  searchableFields,
  routeConfig,
  searchPlaceholder,
  emptyMessage,
}: BackendListWrapperPropsT) {
  // Check if we have data
  if (!data || data.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center">
        <p className="text-lg text-gray-500">
          {emptyMessage || "Keine Daten gefunden."}
        </p>
      </div>
    );
  }

  return (
    <BackendListTable
      data={data}
      columns={columns}
      searchableFields={searchableFields}
      routeConfig={routeConfig}
      searchPlaceholder={searchPlaceholder}
      emptyMessage={emptyMessage}
    />
  );
}
